<template>
    <div
        class="eq-form-row"
        :class="{
            'justify-content-start': props.alignContent === 'start',
            'justify-content-center': props.alignContent === 'center',
            'justify-content-end': props.alignContent === 'end',
        }"
    >
        <slot></slot>
    </div>
</template>
<script setup lang="ts">
const props = defineProps<{
    /**
     * If the row should be aligned to the start, center or end
     * @default 'start'
     */
    alignContent?: 'start' | 'center' | 'end';
}>();
</script>
